import { render, staticRenderFns } from "./PagamentosHistorico.vue?vue&type=template&id=1035361d&scoped=true&"
import script from "./PagamentosHistorico.vue?vue&type=script&lang=js&"
export * from "./PagamentosHistorico.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosHistorico.vue?vue&type=style&index=0&id=1035361d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035361d",
  null
  
)

export default component.exports